import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["srcset"]
const _hoisted_2 = ["srcset", "src", "width", "height"]

import {
    type PropType,
    computed,
    onMounted,
    getCurrentInstance,
    ref,
} from "vue";
import { type IAdvertItem } from "../../list-item";
import { patchSrcSet } from "./patch-src-set";
import { getWindowInnerWidth } from "../../../../../../utilities/browser-size";
import fastdom from "fastdom";
import FastdomPromised from "fastdom/extensions/fastdom-promised";


export default /*@__PURE__*/_defineComponent({
  __name: 'advert-image',
  props: {
    mobile: Boolean,
    item: {
        type: Object as PropType<IAdvertItem>,
        required: true,
    },
    fixedWidth: Number,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
},
  setup(__props) {

const props = __props;

const width = ref(-1);

const instance = getCurrentInstance();
const fd = fastdom.extend(FastdomPromised);

onMounted(async () => {
    if (instance == null) throw new Error("missing instance");
    width.value = await fd.measure(() => {
        const rect = instance?.proxy?.$el.getBoundingClientRect();
        return rect.width;
    });
});

const windowInnerWidth = getWindowInnerWidth();

const actualScale = computed(() => {
    if (width.value === -1) return props.scaleOfScreen;
    return width.value / windowInnerWidth.value;
});

const item_pictureSrcSetAsWebp = computed(() => {
    if (props.mobile) {
        return props.item.mobileImageSrcSetAsWebp;
    } else {
        return props.item.desktopImageSrcSetAsWebp;
    }
});
const item_pictureSrcSet = computed(() => {
    if (props.mobile) {
        return props.item.mobileImageSrcSet;
    } else {
        return props.item.desktopImageSrcSet;
    }
});
const item_pictureUrl = computed(() => {
    if (props.mobile) {
        return props.item.mobileImage;
    } else {
        return props.item.desktopImage;
    }
});
const item_pictureWidth = computed(() => {
    if (props.mobile) {
        return props.item.mobileImageWidth;
    } else {
        return props.item.desktopImageWidth;
    }
});
const item_pictureHeight = computed(() => {
    if (props.mobile) {
        return props.item.mobileImageHeight;
    } else {
        return props.item.desktopImageHeight;
    }
});

const pictureSrcSetAsWebp = computed(() => {
    return patchSrcSet(
        item_pictureSrcSetAsWebp.value,
        props.fixedWidth,
        actualScale.value,
        pictureUrl.value
    );
});
const pictureSrcSet = computed(() => {
    return patchSrcSet(
        item_pictureSrcSet.value,
        props.fixedWidth,
        actualScale.value,
        pictureUrl.value
    );
});
const pictureUrl = computed(() => {
    return patchUrl(item_pictureUrl.value, props.fixedWidth);
});

const pictureWidth = computed(() => {
    return props.fixedWidth != null
        ? props.fixedWidth
        : item_pictureWidth.value;
});
const pictureHeight = computed(() => {
    if (props.fixedWidth != null) {
        const ratio = item_pictureWidth.value / item_pictureHeight.value;
        return props.fixedWidth / ratio;
    }
    return item_pictureHeight.value;
});

function patchUrl(url: string, fixedWidth: number | undefined | null) {
    if (fixedWidth != null) {
        const urlObject = new URL(url);
        urlObject.searchParams.set("width", fixedWidth.toString());
        url = urlObject.toString();
    }
    return url;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", null, [
    (pictureSrcSetAsWebp.value != null)
      ? (_openBlock(), _createElementBlock("source", {
          key: 0,
          srcset: pictureSrcSetAsWebp.value,
          type: "image/webp"
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("img", {
      srcset: pictureSrcSet.value ?? undefined,
      alt: "",
      class: _normalizeClass(['full-width', __props.mobile ? 'mobile-image' : 'desktop-image']),
      src: pictureUrl.value,
      width: pictureWidth.value,
      height: pictureHeight.value
    }, null, 10 /* CLASS, PROPS */, _hoisted_2)
  ]))
}
}

})